
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.91 17.09h2.18V11h-2.18v6.09zM12 9.12c.317 0 .583-.108.798-.322.214-.215.322-.481.322-.798 0-.317-.108-.583-.322-.798A1.084 1.084 0 0012 6.88c-.317 0-.583.108-.798.322-.214.215-.321.48-.321.798 0 .317.107.583.321.798.215.214.481.321.798.321zm0 13.083a9.944 9.944 0 01-3.983-.803 10.298 10.298 0 01-3.238-2.18 10.3 10.3 0 01-2.18-3.237A9.945 9.945 0 011.798 12c0-1.415.268-2.743.803-3.984A10.3 10.3 0 014.78 4.78a10.299 10.299 0 013.237-2.18A9.945 9.945 0 0112 1.798c1.415 0 2.743.267 3.984.803 1.24.535 2.32 1.261 3.237 2.179a10.3 10.3 0 012.18 3.237A9.946 9.946 0 0122.202 12a9.946 9.946 0 01-.803 3.983 10.301 10.301 0 01-2.179 3.238 10.297 10.297 0 01-3.237 2.18 9.944 9.944 0 01-3.984.802z","fill":"#2772DB"}})])
          )
        }
      }
    